export default __webpack_public_path__ + "static/media/menu_news.bc9c35eb.svg";